import { IconName } from '../components/icon';

export const getProductIconName = (product: string): IconName => {
  switch (product) {
    case 'TrialMax':
      return IconName.TrialMax;
    case 'Rater Station':
      return IconName.RaterStation;
    default:
      return IconName.TrialMax;
  }
};

/**
 * Removes spaces, dashes, and underscores from a string
 *
 * @param str - The input string to process
 * @returns The string with spaces, dashes, and underscores removed
 *
 * @example
 * // Returns "HelloWorld"
 * removeSpecialChars("Hello World");
 *
 * @example
 * // Returns "HelloWorld"
 * removeSpecialChars("Hello-World");
 *
 * @example
 * // Returns "HelloWorld"
 * removeSpecialChars("Hello_World");
 */
export const removeSpecialChars = (str: string): string => {
  if (!str) return '';
  return str.replace(/[\s\-_]/g, '');
};
